// 📂 src/config/filtersConfig.js
// Liste des filtres disponibles (liés aux images dans /public/assets)

export const filtersConfig = [
  {
    id: "pirate",
    name: "🏴‍☠️ Pirate",
    src: "/assets/pirate_clean.png",
  },
  {
    id: "bunny",
    name: "🐰 Bunny",
    src: "/assets/bunny_clean.png",
  },
  {
    id: "chapeau",
    name: "🎩 Chapeau",
    src: "/assets/chapeau_clean.png",
  },
  {
    id: "lion",
    name: "🦁 Lion",
    src: "/assets/lionso_clean.png",
  },
  {
    id: "lutin",
    name: "🧝‍♂️ Lutin",
    src: "/assets/lutin_clean.png",
  },
  {
    id: "cartoon-eyes",
    name: "👀 Cartoon Eyes",
    src: "/assets/overlay-eyes-cartoon.png",
  },
  {
    id: "evo-mask",
    name: "🎭 Evo Mask",
    src: "/assets/overlay-evo-mask.png",
  },
  {
    id: "funny-face",
    name: "🤣 Funny Face",
    src: "/assets/overlay-funny-face.png",
  },
];
